module.exports = __webpack_public_path__ + "static/Bridge-813e1dc1883af8c979f977a54a6e5462.jpg";